// Climb physics for ladders / scaffolding / vines (MB.1-remainder). PURE (ENG-1).
// A body inside a block tagged `climbable` doesn't fall freely: holding jump
// climbs up, sneaking holds position (and, on scaffolding, keeps you from
// dropping off the bottom), and otherwise you descend gently — never fast enough
// to take fall damage. The host detects the climbable cell (by tag) and, each
// tick after the normal step, replaces the vertical velocity with climbVy().

/** Blocks are climbable via the `climbable` block tag; this names it for the host. */
export const CLIMBABLE_TAG = 'climbable';

/** Per-tick climb speeds (blocks/tick), matching Minecraft's ladder feel. */
export const CLIMB_UP = 0.12;
export const CLIMB_DOWN = -0.12;

export interface ClimbInput {
  /** Holding jump → climb up. */
  jump?: boolean;
  /** Sneaking → cling in place (and don't fall off scaffolding). */
  sneak?: boolean;
}

/**
 * Vertical velocity while clinging to a climbable block. Jump climbs up; sneak
 * holds still; otherwise the fall is clamped to a gentle controlled descent
 * (so `currentVy` — which already has gravity applied — never exceeds CLIMB_DOWN).
 */
export function climbVy(input: ClimbInput, currentVy: number): number {
  if (input.sneak) return 0;
  if (input.jump) return CLIMB_UP;
  return Math.max(currentVy, CLIMB_DOWN);
}

/** Whether a body on a climbable takes fall damage — it never does (peak resets). */
export function climbingResetsFall(): boolean {
  return true;
}
